import React from 'react';
import { gql, useMutation } from '@apollo/client';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography, Stack } from '@mui/material';
import { Importer, ImporterField } from 'react-csv-importer';
import 'react-csv-importer/dist/index.css';

const IMPORT_COMPANIES = gql`
    mutation ImportCompanies($eventId: String!, $role: String!, $jsonData: String!) {
        importCompanies(eventId: $eventId, role: $role, jsonData: $jsonData) {
            total
            inserted
            duplicates
            failed
            failedRows
        }
    }
`;

export default function CompanyImportDialog({ open, onClose, eventId, role, onReport }) {
    const [rowsBuffer, setRowsBuffer] = React.useState([]);
    const [importCompanies, { loading }] = useMutation(IMPORT_COMPANIES);

    const handleUpload = async () => {
        const res = await importCompanies({
            variables: { eventId, role, jsonData: JSON.stringify(rowsBuffer) },
        });
        onReport?.(res?.data?.importCompanies);
        setRowsBuffer([]);
        onClose?.();
    };

    const isSponsors = String(role).toLowerCase() === 'sponsors';
    const isExhibitors = String(role).toLowerCase() === 'exhibitors';

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth='md'>
            <DialogTitle>Import {role} via CSV</DialogTitle>
            <DialogContent>
                <Box sx={{ mb: 2 }}>
                    <Typography variant='body2' color='text.secondary'>
                        Map your CSV columns to the required fields below, then click Upload.
                    </Typography>
                </Box>

                <Importer
                    chunkSize={1024 * 50}
                    assumeNoHeaders={false}
                    restartable={true}
                    onStart={() => setRowsBuffer([])}
                    processChunk={async rows => {
                        // accumulate rows; Importer may call this multiple times
                        setRowsBuffer(prev => prev.concat(rows));
                    }}
                    onComplete={() => {}}
                >
                    {/* Required/common fields */}
                    <ImporterField name='Email' label='Email' />
                    <ImporterField name='Company' label='Company' />

                    {/* Optional common fields */}
                    <ImporterField name='StallNo' label='Stall No' optional />
                    <ImporterField name='First Name' label='First Name' optional />
                    <ImporterField name='Last Name' label='Last Name' optional />
                    <ImporterField name='Designation' label='Designation' optional />

                    {/* Role-specific */}
                    {isSponsors && (
                        <>
                            <ImporterField name='allowedRegistrations' label='Allowed Registrations (VIP)' />
                            <ImporterField name='allowed_no_of_staff' label='Allowed Registrations (Delegate)' />
                        </>
                    )}
                    {isExhibitors && (
                        <ImporterField name='allowedRegistrations' label='Allowed Registrations (Staff)' />
                    )}
                </Importer>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={loading}>
                    Cancel
                </Button>
                <Button variant='contained' onClick={handleUpload} disabled={loading || rowsBuffer.length === 0}>
                    {loading ? 'Uploading…' : 'Upload'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
